if (!customElements.get('wls-how-to-video')) {
    class WLSHowToVideo extends HTMLElement {
        constructor() {
            super();

            this.classes = {
                video: 'js-wls-video-single',
                videoWrapper: 'js-wls-video-single-wrapper',
                playingClass: 'playing'
            };

            this.elements = {
                video: this.querySelector(`.${this.classes.video}`),
                videoWrapper: this.querySelector(`.${this.classes.videoWrapper}`)
            };

            document.addEventListener("DOMContentLoaded", this.initialize.bind(this));
        }

        initialize() {
            if (this.elements.video) {
                this.initializeVideoLogic();
            }
        }

        initializeVideoLogic() {
            if (this.elements.video) {
                this.elements.video.addEventListener('click', () => {
                    if (this.elements.video.paused) {
                        this.elements.video.play();
                        this.elements.videoWrapper.classList.add(this.classes.playingClass);
                    } else {
                        this.elements.video.pause();
                        this.elements.videoWrapper.classList.remove(this.classes.playingClass);
                    }
                })
            }
        }

    }
    window.customElements.define('wls-how-to-video', WLSHowToVideo);
}

